import { MutationHookOptions, useMutation } from '@apollo/client'
import { RemoveCode, RemoveCodeVariables } from '__generatedTypes__/RemoveCode'
import { REMOVE_CODE } from 'queries/institutionalCodes'

export function useRemoveCodeMutation(options?: MutationHookOptions<RemoveCode, RemoveCodeVariables>) {
  return useMutation<RemoveCode, RemoveCodeVariables>(REMOVE_CODE, options)
}
